module.exports = __webpack_public_path__ + "static/media/valor3_4.fd1e2359.png";